<template>
  <div class="news">
    <news-list :newsList="newsList" v-if="!show">
      <pagination
        :page-size="10"
        :total="51"
        :pager-count="pagerCount"
        @selectCount="selectCount"
      ></pagination>
    </news-list>
    <news-Article v-if="show"></news-Article>
  </div>
</template>
<script>
import { getNewsList } from "@/api";
import newsArticle from "./components/newsArticle";
import newsList from "./components/newsList";
import pagination from "@/components/Pagination";
export default {
  components: {
    ["news-Article"]: newsArticle,
    ["news-list"]: newsList,
    pagination,
  },
  data () {
    return {
      newsList: [],
      show: false,
      pagerCount: 1,
    };
  },
  methods: {
    detail () { },
    selectCount (Count) {
      this.pagerCount = Count;
    },
    getNewsArticle () {
      console.log(this.$route);
    },
    async getNewsList () {
      const result = await getNewsList();
      this.newsList = result.data.data;
    },
    routeHandle () {
      if (this.$route.hash === "#article") {
        this.show = true;
        this.getNewsArticle();
      } else {
        this.show = false;
        this.getNewsList();
      }
    },
  },
  created () {
    this.routeHandle();
  },
  watch: {
    $route () {
      this.routeHandle();
    },
  },
};
</script>
<style lang="scss" scoped>
.news {
  width: 698px;
  padding: 0.2rem;
}
</style>e